// Веб-вклад модуля `recordings` — запись лекций.
//
// `/recordings/new` держит собственный overlay-каркас (без топбара и рельса),
// но панель репетитора на нём БОЛЬШЕ НЕ подавляется (2026-08-17): открытая
// панель пропадала при входе на экран записи, хотя спросить по ходу лекции —
// ровно тот сценарий, ради которого панель глобальная. Микрофон при этом не
// конфликтует: репетитор в панели текстовый, голосовой ввод — отдельный режим.

import { SECTION_ICONS, SECTION_TINT } from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const recordingsWebManifest = {
	id: "recordings",
	icon: SECTION_ICONS.recordings,
	labelKey: "nav.recording",
	tint: SECTION_TINT.recordings,
	routes: ["/recordings"],
	overlayShellPrefixes: ["/recordings/new"],

	// Баннер объясняет МЕХАНИКУ (расшифровка идёт по ходу лекции, а не после)
	// и разграничивает с аудио-резюме: там обратное направление, текст → звук.
	// Третий пункт снимает ложное ожидание «загружу готовый файл».
	intro: {
		titleKey: "recordings:intro.title",
		bodyKey: "recordings:intro.body",
		bulletKeys: [
			"recordings:intro.bullets.0",
			"recordings:intro.bullets.1",
			"recordings:intro.bullets.2",
		],
	},

	nav: [
		{
			key: "recordings",
			to: "/recordings",
			icon: SECTION_ICONS.recordings,
			labelKey: "nav.recording",
			order: 60,
			badge: {
				kind: "powersync",
				sql: "SELECT count(*) FROM lecture_sessions WHERE user_id = ? AND deleted_at IS NULL",
			},
		},
	],

	launch: [
		{
			key: "recordLecture",
			icon: SECTION_ICONS.recordings,
			tint: SECTION_TINT.recordings,
			titleKey: "launcher.recordLecture",
			hintKey: "launcher.recordLectureHint",
			to: "/recordings/new",
			order: 50,
		},
	],
} satisfies WebModuleManifest;
